<script>
    import reportService from '../../routes/report/v2-service.js';
    import dayjs from 'dayjs';


    let {
        value,
        rowIndex,
        rowId,
        instructKey
    } = $props();

    let is_downloading = $state(false);

    const getFormattedDate = (dateString) => {
        return dayjs(dateString).format("YYYY/MM/DD.HHmmss");
    }

    const downloadReport = async (id, template, created_at) =>{
        event.stopPropagation();
        if (event.target === event.currentTarget) {
            let cr_at = getFormattedDate(created_at);
            let file_name;

            if(!template){
                file_name = "report"
            }

            if (template.includes("standard_spanish")) {
                if (template.includes("html")) {
                    file_name = `${cr_at}.vulseek.reporte.html`;
                }
                else {
                    file_name = `${cr_at}.vulseek.reporte.pdf`;
                }
            }
            if (template.includes("standard_english")) {
                if (template && template.includes("html")) {
                    file_name = `${cr_at}.vulseek.report.html`;
                }
                else {
                    file_name = `${cr_at}.vulseek.report.pdf`;
                }
            }
            if (value.options.includes("language=es")) {
                if (template.includes("html")) {
                    file_name = `${cr_at}.vulseek.reporte.html`;
                }
                else {
                    file_name = `${cr_at}.vulseek.reporte.pdf`;
                }
            }
            if (value.options.includes("language=en")) {
                if (template && template.includes("html")) {
                    file_name = `${cr_at}.vulseek.report.html`;
                }
                else {
                    file_name = `${cr_at}.vulseek.report.pdf`;
                }
            }

            is_downloading = true;


            const file = await reportService.downloadSavedReport(id)
                .catch((e) => {
                    is_downloading = false;
                    loadingCustom = false;
                    error = e;
                })
            ;

            if (file) {
                const fileBlob = await file.blob();
                const fileUrl = URL.createObjectURL(fileBlob);
                const anchor = document.createElement("a");
                anchor.href = fileUrl;
                anchor.download = file_name;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);

                URL.revokeObjectURL(fileUrl);
            }
            is_downloading = false;
        }
    }
</script>
<style>
button{
    position: relative;
    z-index: 99999999999999999999999;
}
</style>
<button class="btn btn-default" onclick={()=>downloadReport(value.id, value.template, value.created_at)}>
    {#if !is_downloading}
        <i class="fas fa-save" onclick={()=>downloadReport(value.id, value.template, value.created_at)}  style="color: #666 !important;"></i>
    {:else}
    <div class="overlay text-center">
        <i class="fas fa-sync-alt fa-spin"></i>
    </div>
    {/if}

</button>
